import { useUnifiedAuth } from 'components/Common/UnifiedAuthContext';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import useConfirm from 'hooks/use-confirm';
import { useHttp } from 'hooks/use-fetch';
import * as React from 'react';
import { auth } from 'utils/spaUrls';
import { trackMixpanelEvent } from 'utils/utilMethods';
import { MixpanelEventName } from 'utils/constants';

export default function Logout() {
  const { logout } = useUnifiedAuth();
  const { hasUnsavedChanges } = useHttp();
  const onLogout = React.useCallback(() => {
    localStorage.clear();
    sessionStorage.clear();
    logout({ returnTo: `${window.location.origin}${auth.login}` });
    trackMixpanelEvent(MixpanelEventName.APP_SESSION_END);
  }, [logout]);

  const { showConfirm, ConfirmDialog } = useConfirm();

  const handleLogout = () => {
    trackMixpanelEvent(MixpanelEventName.HEADER_LOGOUT_BUTTON_CLICKED, {
      hasUnsavedChanges,
    });
    if (hasUnsavedChanges) {
      showConfirm({
        message: 'Are you sure you want to logout?',
        onConfirm: onLogout,
      });
    }
    else {
      onLogout();
    }
  };

  return (
    <>
      <ConfirmDialog />
      <MenuItem onClick={handleLogout}><Typography color='primary'>Logout</Typography></MenuItem>
    </>
  );
}
